import { reaction } from '@reatom/framework'

import {
  joinedInviteCodeAtom,
  openChangeInviteCodeDialogEvent,
} from '@root/entities/referral'
import { isInitializationReadyAtom } from '@root/features/initialization/atoms/common'

export const joinReferralCodeReaction = reaction((ctx) => {
  const inviteCode = ctx.spy(joinedInviteCodeAtom)
  const isReady = ctx.spy(isInitializationReadyAtom)

  if (!inviteCode || !isReady) {
    return
  }

  openChangeInviteCodeDialogEvent(ctx, {
    inviteCode,
  })

  joinedInviteCodeAtom(ctx, undefined)
}, 'joinReferralCodeReaction')
